import { useState } from "react";
import React from "react";
import CategoriesDropdown from "../components/CategoriesDropdown";
import MenuButton from "../components/MenuButton";
import SearchBar from "../components/SearchBar";
import { Link } from "gatsby";
import { navLinks } from "../constants/navLinks";

const Header = ({ headerHeight }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.style.overflow = isMenuOpen ? "auto" : "hidden"; // Disable scrolling when menu is open
  };

  return (
    <header
      className={`flex dark:bg-black_primary bg-white_primary justify-between items-center p-normal w-full fixed top-0 transition-transform duration-300 z-[20] shadow`}
      style={{ height: headerHeight }}
    >
      <div className="h-full w-[1264px] m-auto flex justify-between items-center">
        <Link to="/">
          <p className="text-2xl flex flex-col" id="logo">
            Garden Hub
          </p>
        </Link>
        <ul className="flex gap-8 max-lg:hidden">
          {navLinks.map((item, index) => (
            <li key={index} className="text-[20px] ">
              <Link to={item.link} aria-label={`Navigate to ${item.name}`}>
                {" "}
                {item.name}{" "}
              </Link>
            </li>
          ))}
        </ul>
        <div className="flex gap-2 justify-center items-center">
          <SearchBar add_class="max-md:hidden  lg:w-[200px] " />
          <MenuButton toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />
        </div>

        <nav
          className={`absolute top-0 p-normal right-0 dark:bg-black_primary bg-white_primary w-full z-[20] duration-500 transition-transform ease-in-out ${
            isMenuOpen ? "translate-x-0" : "translate-x-[100%]"
          }`}
          id="menu"
          style={{
            marginTop: headerHeight,
            minHeight: "120vh",
            overflowY: "auto",
          }}
        >
          <SearchBar toggleMenu={toggleMenu} add_class="md:hidden mb-thin" />
          <ul>
            {navLinks.map((item, index) => (
              <li
                key={`${index}_${item.name}`}
                className="border-b-[1px] border-black_primary dark:border-white_primary last:border-b-0 text-[20px] "
              >
                {item.name === "Categories" ? (
                  <CategoriesDropdown />
                ) : (
                  <Link
                    to={item.link}
                    onClick={toggleMenu}
                    className={`nav-link flex items-center py-thin`}
                    aria-label={`Navigate to ${item.name}`}
                  >
                    {item.name}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
